import React, { Fragment } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    makeStyles,
    IconButton,
    Grid,
    Button,
    TextField,
    colors,
} from "@material-ui/core";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../help/Api";
import { useEffect } from "react";
import { sto } from "../../../../Context/InshData";
import { useTranslation } from "react-i18next";
import ItemsDetails from "./ItemInfo/ItemsDetails";
import moment from "moment";
import { useStylesLbl } from "../../../../St/Reports/UseStyle";
import { stElemnt } from "../../../../St/comps/cStyle";

export const useStylesItemDilog = makeStyles((theme) => ({
    dialog: {
        padding: theme.spacing(2),
        position: "absolute",
        top: theme.spacing(5),
    },
    dialogTawla: {
        padding: theme.spacing(1),
        position: "absolute",
        top: theme.spacing(1),
        width: "200mm"
    },
    dialogCheckRest: {
        padding: theme.spacing(1),
        position: "absolute",
        top: theme.spacing(1),
        width: "250mm"
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },
    dialogTitle: {
        textAlign: "center",
    },
    dialogContent: {
        textAlign: "center",
    },
    dialogAction: {
        justifyContent: "center",
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        "&:hover": {
            backgroundColor: theme.palette.secondary.light,
            cursor: "default",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "8rem",
        },
    },
}));

export default function ItemDataDialog(props) {
    const { infoData, setInfoData, PrTy_InPr, isPurches, isStock, isMake, permistionInv } = props;
    const classes = useStylesItemDilog();
    const stylH = isPurches ? stElemnt.SubHPruch : isStock ? stElemnt.SubHSafes : isMake ? stElemnt.SubHMake : stElemnt.SubHMu;

    const [rptParams, setRptParams] = React.useState({
        dateFrom: moment(new Date()).subtract().format("YYYY") + "-01-01",
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        branch: sto?.branchi,
        safe: -1,
        curr: infoData?.curr_id,
        center: -1,
        doc_type: '001'
    });
    const getCloseDialog = () => {
        setInfoData({ ...infoData, open: false });
        setRptParams({ ...rptParams, doc_type: '001' });
    };

    return (
        <Dialog open={infoData.open} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>

                <ItemSafesTable barcode={infoData?.barcode} curr_id={infoData?.curr_id}
                    permistionInv={permistionInv} stylH={stylH} />
                {/* <hr /> */}
                <ItemsDetails
                    {...{
                        rptParams,
                        setRptParams,
                        isPurches, isStock, isMake,
                        curr_id: infoData?.curr_id
                    }}
                />
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button onClick={() => getCloseDialog()}>إغلاق </Button>
            </DialogActions>
        </Dialog>
    );
}

function ItemSafesTable(props) {
    const { barcode, curr_id, permistionInv, stylH } = props;
    const classes = useStylesItemDilog();
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
        Urls = `TaswyaBasicData/countValSafes?curr_id=${curr_id}&&barcode=${barcode}&&branch=${sto.branchi}`
    } else {
        Urls = `TaswyaBasicData/countValSafes?curr_id=${curr_id}&&barcode=${barcode}
        &&branch=${sto.branchi}&&db_name=${sto.db_name}`
    }
    const { data, fetching, fetchURL } = useFetchURL({
        ...{
            url:
                uri + Urls,
            dependencyArray: [],
        },
    });
    const { t } = useTranslation(["forms"]);
    useEffect(() => {
        console.log("the data is", data);
    });
    const claslbl = useStylesLbl();

    if (!data || fetching || !data?.barcodes) return <></>;
    return (
        <>
            <React.Fragment>
                <Grid container style={{ padding: 5 }} spacing={1}>
                    <Grid container item xs={12}>
                        <Typography
                            size="small"
                            className={classes.headerTitle}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            color="primary"
                        >
                            {data?.barcodes[0]?.barcode}
                        </Typography>
                    </Grid>
                    <Grid container item xs={12}>
                        <Typography
                            size="small"
                            className={classes.headerTitle}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            color="primary"
                        >
                            {data?.barcodes[0]?.symbol}
                        </Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="id"
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            label={t("forms:barcode")}
                            name="barcodeS"
                            value={data?.barcodes[0]?.barcode}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="id"
                            label={t("sale-price")}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="barcodeS"
                            value={data?.barcodes[0]?.sale}
                        />

                    </Grid>
                    {!permistionInv?.HIDEPURCH &&
                        (
                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="id"
                                    label={t("purch-price")}
                                    InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="burch"
                                    value={data?.barcodes[0]?.purch}
                                />
                            </Grid>
                        )}

                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="id"
                            label={t("unit")}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="unit"
                            value={data?.barcodes[0]?.unitName}
                        />
                    </Grid>
                    {!permistionInv?.HIDEPURCH &&
                        (
                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="id"
                                    label={"متوسط التكلفة"}
                                    InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="avgCost"
                                    value={data?.balance[0]?.avgCost}
                                />
                            </Grid>
                        )}

                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>

                    </Grid>
                </Grid>
            </React.Fragment>

            <Fragment>
                <Grid container xs={12}>
                    <Grid item xs={4} style={stylH}>
                        {t("quanity")}
                    </Grid>
                    <Grid item xs={4} style={stylH}>
                        {t("safe")}
                    </Grid>
                    <Grid item xs={4} style={stylH}>
                        {t("branch")}
                    </Grid>
                    {data?.balance?.map((d) => {
                        return (
                            <Grid
                                xs={12}
                                container
                                item
                                style={{ backgroundColor: `${d.Qtys > 0 ? "#00ff00" : "#fff"}` }}
                            >
                                <Grid item xs={4}>
                                    {d.Qtys}
                                </Grid>
                                <Grid item xs={4}>
                                    {/* {" "} */}
                                    {d.name}
                                </Grid>
                                <Grid item xs={4}>
                                    {/* {" "} */}
                                    {d.nameBranch}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            </Fragment>
        </>

    );
}
